import { render } from "./OrderItemTimeline.vue?vue&type=template&id=8f2c42d8&scoped=true"
import script from "./OrderItemTimeline.vue?vue&type=script&lang=js"
export * from "./OrderItemTimeline.vue?vue&type=script&lang=js"

import "./OrderItemTimeline.vue?vue&type=style&index=0&id=8f2c42d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2c42d8"]])

export default __exports__
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTimeline,QTimelineEntry});
